import { render } from "./randomPaper.vue?vue&type=template&id=74dc0ed5&scoped=true"
import script from "./randomPaper.vue?vue&type=script&lang=js"
export * from "./randomPaper.vue?vue&type=script&lang=js"

import "./randomPaper.vue?vue&type=style&index=0&id=74dc0ed5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dc0ed5"]])

export default __exports__